import Sortable from 'sortablejs'
document.addEventListener('turbo:load', () => {
  window.Sortable = Sortable
})
